import React from "react";
import { dateFormatterUI } from "../../../utils/helpers/dataHelper";
import "../../container.css";
import { useHistory } from "react-router-dom";

export default function AnnouncementDashboard({
  link,
  latestAnnouncement,
  imageHeight,
}) {
  const history = useHistory();
  return (
    <div className="rounded cursor-pointer" onClick={() => history.push(link)}>
      <div className="">
        <img
          className={`object-fill w-screen ${imageHeight}`}
          src={latestAnnouncement.imageUrl}
          alt={latestAnnouncement.title}
        />
      </div>
      <div className="mx-5">
        <div className="p-2 accouncement_desc">
          <div className="text-yellow-400 text-xs">
            {dateFormatterUI(latestAnnouncement.dateCreated)}
          </div>
          <div className="two_line text-md">{latestAnnouncement.title}</div>
        </div>
      </div>
    </div>
  );
}
